define('util/FeatureToggleDisabledError',[],function () {
    'use strict';
    function FeatureToggleDisabledError(featureToggle) {
        this.message = 'The provided feature toggle (' + featureToggle + ') is currently disabled.';
        this.featureToggle = featureToggle;
    }
    FeatureToggleDisabledError.prototype = Object.create(Error.prototype);
    FeatureToggleDisabledError.prototype.constructor = FeatureToggleDisabledError;
    return FeatureToggleDisabledError;
});
